// RFC 4122 v1-v5 UUID validator. Used at URL-param boundaries before
// passing values into PostgREST `eq('id', uuid)` calls, which would
// otherwise raise a raw "invalid input syntax for type uuid" error
// and bubble up an ugly toast.
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuid(value: string | null | undefined): value is string {
  return typeof value === 'string' && UUID_PATTERN.test(value);
}

export function parseUuidParam(
  value: string | null | undefined,
): string | null {
  return isUuid(value) ? value : null;
}
